module.exports = __webpack_public_path__ + "static/media/fly0004.60a01c5f.webp";